import { useEffect, useRef, useState } from 'react';
import { logger } from '../../../API/services/SharedService';

export function useLocalMedia({
  audio,
  video,
  retryCount,
}: {
  audio?: boolean;
  video?: boolean | MediaTrackConstraints;
  retryCount?: any
}): {
    error: Error | undefined;
    media: MediaStream | undefined;
    cancel: () => void;
  } {
  const [media, setMedia] = useState<MediaStream>();
  const [error, setError] = useState<Error>();
  const isCancelled = useRef(false);
  console.log(audio, video, 'videoaudio', retryCount);
  useEffect(() => {
    if (isCancelled.current) {
      return undefined;
    }

    if (!video && !audio) {
      return undefined;
    }

    let newMedia: MediaStream;

    navigator.mediaDevices
      .getUserMedia({ video, audio })
      .then((mediaStream) => {
        newMedia = mediaStream;
        if (isCancelled.current) {
          newMedia.getTracks().forEach((track) => {
            track.stop();
          });
          return;
        }
        console.log(mediaStream, 'mediastream');
        setMedia(mediaStream);
      })
      .catch(
        logger.withErrorLog((err) => {
          if (isCancelled.current) {
            return;
          }
          setError(err);
        }),
      );

    return function cleanup() {
      if (retryCount! > 0) {
        isCancelled.current = true;

        newMedia?.getTracks().forEach((track: MediaStreamTrack) => {
          track.stop();
        });
      }
    };
  }, [video, audio, isCancelled]);

  const cancel = (): void => {
    if (retryCount ! > 0) isCancelled.current = true;
  };

  return {
    error,
    media,
    cancel,
  };
}
